import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addToCartPurchasePbf } from "../../../services/purchaseApi";

export const useAddToCartPbf = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: addToCartPurchasePbf,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["purchase-cart-pbf"] }); // invalidates cart
        }
    });
};
